module.exports = __webpack_public_path__ + "static/media/winterwizardjam.a9473c64.png";